export default __webpack_public_path__ + "static/media/4.5df47386.svg";